import { c as _c } from "react-compiler-runtime";
import { useCallback, useRef } from 'react';
import styled from 'styled-components';
import { Popover } from 'foundations-components/transitional/components/Popover';
import useCollaborationSidebarState from '../../hooks/useCollaborationSidebarState';
import EmbeddedCommentIframe from './components/EmbeddedCommentIframe';
import { MINI_COMMENTER_ID } from '../../constants/sidebar';
import { useEmbeddedCommentPopover } from './hooks/useEmbeddedCommentPopover';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const PopoverContentOverlay = styled.div.withConfig({
  displayName: "EmbeddedCommentPopover__PopoverContentOverlay"
})(["pointer-events:none;position:fixed;top:", "px;left:", "px;width:", "px;height:", "px;"], ({
  top
}) => top, ({
  left
}) => left, ({
  width
}) => width, ({
  height
}) => height);
const PopoverChild = ({
  iframeContainerID,
  embeddedPopoverContentRef,
  popoverContentWrapperRef
}) => {
  const {
    onUpdateCollaborationSidebarState
  } = useCollaborationSidebarState();
  const closeEmbeddedCommentPopover = useCallback(() => {
    onUpdateCollaborationSidebarState({
      isEmbeddedPopoverOpen: false,
      commentableAreaClickCoordinates: undefined
    });
  }, [onUpdateCollaborationSidebarState]);
  const {
    dimensionsAndCoordinates
  } = useEmbeddedCommentPopover({
    iframeContainerID,
    popoverContentWrapperRef,
    closeEmbeddedCommentPopover
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(PopoverContentOverlay, {
      "data-test-id": "embedded-comment-popover-content-overlay",
      ref: embeddedPopoverContentRef,
      top: dimensionsAndCoordinates.top,
      left: dimensionsAndCoordinates.left,
      width: dimensionsAndCoordinates.width,
      height: dimensionsAndCoordinates.height
    })
  });
};
export default function EmbeddedCommentPopover(t0) {
  "use memo";

  const $ = _c(15);
  const {
    iframeContainerID
  } = t0;
  const {
    isEmbeddedPopoverOpen,
    embeddedPopoverPlacement,
    embeddedModuleID,
    embeddedMetaDescription,
    isEmbeddedOpenFromCommentMode,
    onUpdateCollaborationSidebarState
  } = useCollaborationSidebarState();
  let t1;
  if ($[0] !== onUpdateCollaborationSidebarState) {
    t1 = () => {
      onUpdateCollaborationSidebarState({
        isEmbeddedPopoverOpen: false,
        commentableAreaClickCoordinates: undefined
      });
    };
    $[0] = onUpdateCollaborationSidebarState;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const closeEmbeddedCommentPopover = t1;
  const embeddedPopoverContentRef = useRef(null);
  const popoverContentWrapperRef = useRef(null);
  let t2;
  if ($[2] !== closeEmbeddedCommentPopover || $[3] !== embeddedMetaDescription || $[4] !== embeddedModuleID || $[5] !== isEmbeddedOpenFromCommentMode || $[6] !== isEmbeddedPopoverOpen) {
    t2 = embeddedModuleID && embeddedMetaDescription ? /*#__PURE__*/_jsx("div", {
      id: MINI_COMMENTER_ID,
      ref: popoverContentWrapperRef,
      children: /*#__PURE__*/_jsx(EmbeddedCommentIframe, {
        onRequestClose: closeEmbeddedCommentPopover,
        isOpen: isEmbeddedPopoverOpen,
        autoFocusCommenter: isEmbeddedOpenFromCommentMode,
        embeddedModuleID: embeddedModuleID,
        embeddedMetaDescription: embeddedMetaDescription
      }, embeddedModuleID)
    }) : null;
    $[2] = closeEmbeddedCommentPopover;
    $[3] = embeddedMetaDescription;
    $[4] = embeddedModuleID;
    $[5] = isEmbeddedOpenFromCommentMode;
    $[6] = isEmbeddedPopoverOpen;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== iframeContainerID) {
    t3 = /*#__PURE__*/_jsx(PopoverChild, {
      iframeContainerID: iframeContainerID,
      embeddedPopoverContentRef: embeddedPopoverContentRef,
      popoverContentWrapperRef: popoverContentWrapperRef
    });
    $[8] = iframeContainerID;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== embeddedPopoverPlacement || $[11] !== isEmbeddedPopoverOpen || $[12] !== t2 || $[13] !== t3) {
    t4 = /*#__PURE__*/_jsx(Popover, {
      arrowSize: "none",
      inlineSize: "380px",
      overflow: "hidden",
      "data-test-id": "mini-commenter-popover",
      "data-onboarding": "mini-commenter-popover",
      open: isEmbeddedPopoverOpen,
      placement: embeddedPopoverPlacement,
      content: t2,
      children: t3
    });
    $[10] = embeddedPopoverPlacement;
    $[11] = isEmbeddedPopoverOpen;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}